import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

export const RevenueChart: React.FC = () => {
  // Datos de muestra de ingresos por año (últimos 6 años)
  const series = [{
    name: 'Ingresos por Licenciamiento',
    data: [450000, 620000, 780000, 950000, 1200000, 1600000]
  }];

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false
      },
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        dataLabels: {
          position: 'top',
        },
        columnWidth: '60%'
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return '$' + (val / 1000000).toFixed(1) + 'M';
      },
      offsetY: -25,
      style: {
        fontSize: '12px',
        colors: ['#304758'],
        fontWeight: 600
      }
    },
    xaxis: {
      categories: ['2019', '2020', '2021', '2022', '2023', '2024'],
      labels: {
        style: {
          fontSize: '12px',
          fontWeight: 500
        }
      }
    },
    yaxis: {
      labels: {
        formatter: function (val: number) {
          return '$' + (val / 1000000).toFixed(1) + 'M';
        },
        style: {
          fontSize: '12px'
        }
      },
      title: {
        text: 'Ingresos (USD)',
        style: {
          fontSize: '14px',
          fontWeight: 600
        }
      }
    },
    colors: ['#3B82F6'],
    grid: {
      borderColor: '#E5E7EB',
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true
        }
      }
    },
    tooltip: {
      y: {
        formatter: function (val: number) {
          return '$' + val.toLocaleString('es-CO', { minimumFractionDigits: 0 });
        }
      },
      theme: 'light'
    },
    title: {
      text: 'Ingresos por Licenciamiento (Histórico)',
      align: 'left',
      style: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#111827'
      }
    },
    subtitle: {
      text: 'Evolución de ingresos anuales por contratos de licenciamiento',
      align: 'left',
      style: {
        fontSize: '14px',
        color: '#6B7280'
      }
    }
  };

  return (
    <div className="w-full">
      <Chart
        options={options}
        series={series}
        type="bar"
        height={350}
      />
    </div>
  );
};
